/**
 * @flow
 */

import React from 'react';
import styled from 'styled-components';
import { Icon } from 'semantic-ui-react';

import { PhoneInput as BasePhoneInput } from '../../../../components';

const PhoneInput = styled(BasePhoneInput)`
    &.disabled {
        &,
        input:disabled,
        .disabled {
            opacity: 1 !important;
            background-color: #fffaf3;
        }
    }
`;

type PhoneFieldProps = {
    userLookupStatus: string,
    disabled?: boolean,
};

const PhoneField = ({
    userLookupStatus,
    disabled,
    ...props
}: PhoneFieldProps) => (
    <PhoneInput
        {...props}
        className={disabled ? 'disabled' : ''}
        disabled={disabled}
        icon={
            userLookupStatus === 'EXISTS' && (
                <Icon name="checkmark" color="green" inverted circular />
            )
        }
        loading={userLookupStatus === 'CHECKING'}
    />
);

export default PhoneField;
